import styled from 'styled-components';

export const StyledMap = styled('div')`
    font-family: ${(props) => props.theme.fontText};
    .map-wrap {
        height: 450px;
        
        .zoom-container {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;

            .zoom-container-in {
                margin: 15px 0;
            }

            .zoom-container-out {
                margin: 0 15px 0 0;
            }
        }
        
        .on-map-btn-wrapper {
            position: relative;

            .on-map-btn {
                position: absolute;
                left: 30px;
                bottom: 30px;
            }
        }
        
        .ant-card {
            background-color: ${(props) => props.theme.white};
            height: 360px !important;
        }
        
        .ant-card-body {
            padding: 10px;
            display: flex;
            flex-direction: column;
            justify-content: unset;
            height: 100%;
        }

        .kurFqn, .product-tags, .tags, .tag {
            background-color: ${(props) => props.theme.topPriceBgColor};
            font-size: 13px;
            border-radius: 2px;
            height: 22px;
            width: 75px;
            align-items: center;
            justify-content: center;
            display: flex;
            color: ${(props) => props.theme.white};
        }
    }

    .wrapper {
        height: 450px;

        .form-container {
            display: flex;
            justify-content: center;
            height: 450px;
            overflow-y: scroll;
            width: 438px;
            z-index: 1;
            margin-left: 0;
        }
    }

    .back-to-list-btn-wrapper {
        padding: 10px 10px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }

    .farms-list {
        flex-wrap: wrap;
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 261px));
        gap: 32px;
        justify-content: center;

        .ant-card {
            background-color: ${(props) => props.theme.white};

            .qmarks {
                gap: 5px;
            }

            .rect-angle-wrap {
                display: none;
            }
            .farm-name {
                overflow: hidden;
                max-height: 70px;
            }
        }
    }

    .form-container {
        position: absolute;
        z-index: 1000;
        margin-left: 40px;
        background-color: ${(props) => props.theme.white};
    }

    #map-popup {
        font-family: ${(props) => props.theme.fontText};
        position: relative;
        right: 90px;
    }
    
    .ant-pagination {
      padding-top: 50px;
      display: flex !important;
      justify-content: center !important;
    
      li {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        font-family: ${({ theme }) => theme.fontText} !important;
      }
    }

    .ant-pagination-item-link {
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 50% !important;
        transition: background-color 0.3s ease !important;
    }

    .ant-pagination-item-link:hover {
        background-color: ${({ theme }) => theme.lightGrey} !important;
    }

    .ant-pagination-item {
      border: none !important;
      background: transparent !important;
      font-weight: 500 !important;
      color: ${({ theme }) => theme.colorText} !important;
      width: 40px !important;
      height: 40px !important;
      line-height: 32px !important;
      text-align: center !important;
      border-radius: 50% !important;
      transition: all 0.3s ease !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .ant-pagination-item:not(.ant-pagination-item-active):hover {
      background-color: ${({ theme }) => theme.lightGrey} !important;
      color: ${({ theme }) => theme.colorText} !important;
    }
    
    .ant-pagination-item-active,
    .ant-pagination-item-active:hover {
      background-color: ${({ theme }) => theme.brand01} !important;
      border-color: ${({ theme }) => theme.brand01} !important;
      color: ${({ theme }) => theme.white} !important;
      font-weight: bold !important;
      border-radius: 50% !important;
    }
    
    .ant-pagination-item-active a,
    .ant-pagination-item-active:hover a {
      color: ${({ theme }) => theme.white} !important;
    }
    
    .ant-pagination-prev,
    .ant-pagination-next {
      color: ${({ theme }) => theme.colorText} !important;
      width: 40px !important;
      height: 40px !important;
      border-radius: 50% !important;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color 0.3s ease !important;
      background: transparent !important;
      box-shadow: none !important;       
      border: none !important;           
      outline: none !important;          
      padding: 0 !important;             
    }
    
    .ant-pagination-prev:hover,
    .ant-pagination-next:hover {
      background-color: ${({ theme }) => theme.lightGrey} !important;
    }

    .ant-pagination-prev.ant-pagination-disabled:hover,
    .ant-pagination-next.ant-pagination-disabled:hover {
      background-color: transparent !important;
    }
    
    .ant-pagination-prev {
      margin-inline-end: 0;
      margin-right: 24px;
    }
    
    .ant-pagination-next {
      margin-left: 16px;
    }
    
    .ant-pagination-item-link span {
      color: ${({ theme }) => theme.paginationLink};
    }

    @media only screen and (max-width: 1305px) {
        .farms-list {
            grid-template-columns: repeat(4, minmax(0, 261px));
        }
    }
`;
